import type { Config } from 'mixpanel-browser';

import { sanitizeMixpanelUrl } from './MixpanelPrivacy';
import { sanitizeMixpanelReplayEvent } from './MixpanelReplayPrivacy';

export const MIXPANEL_REPLAY_CONFIG = {
  record_sessions_percent: 0,
  remote_settings_mode: 'disabled',
  record_mask_all_text: false,
  record_mask_all_inputs: false,
  record_block_selector:
    'img, video, canvas, iframe, svg, object, embed, script, noscript, meta, [data-replay-block]',
  record_console: false,
  record_network: false,
  record_canvas: false,
  record_heatmap_data: false,
  record_collect_fonts: false,
  record_preserve_identity: true,
  record_url_sanitizer: sanitizeMixpanelUrl,
  record_event_sanitizer: sanitizeMixpanelReplayEvent,
} satisfies Partial<Config>;
